<template>
  <!--store password modal  -->
  <Modal rounded="42px" :isOpen="isModalOpen" :changeModalState="closeModal" :hideHeadersBorder="true">
    <div class="flex px-[30px] pb-[30px] justify-between gap-6 items-center my-[40px] ">
      <div class="w-full max-w-[300px] mx-auto">
        <h5 class="text-center mt-2 mb-[20px] font-bold text-[18px] whitespace-nowrap xl:text-[28px]">{{
          $t('general.add_store_password') }}</h5>
        <p class=" text-center text-[14px] text-[#A5A5A5] max-w-[270px] xl:text-start">{{
          $t('general.store_password_modal_content') }}</p>
        <form @submit.prevent="onSubmit" action="">
          <div class="mb-2 mt-4">
            <span class="block mb-[10px] text-[14px] text-[#C1C1C1]">{{
              $t("general.password")
            }}</span>
            <!-- input password with icon -->
            <div class="relative mt-2 ">
              <div
                class="absolute inset-y-0 right-0 ltr:left-0 pr-3.5 ltr:pr-0 ltr:pl-3.5 flex items-center pointer-events-none">
                <img src="@/assets/auth/login/lock.svg" alt="" />
              </div>
              <!-- :class="v$.formData.password.$error ? 'border-[#ed0d0d]' : 'border-[#E6E6E6]'" -->
              <input v-model="formData.password" :type="`${showPass ? 'text' : 'password'}`"
                class=" outline-none border bg-[#E5E5E58F] border-none text-gray-900 rounded-[5px] focus:border-blue-500 sm:text-[.8rem] text-[0.9rem] block w-full px-10 p-2.5"
                :placeholder="$t('user.auth.password')" />
              <div @click="showPass = !showPass"
                class="absolute inset-y-0 left-0 ltr:left-auto ltr:right-0 pl-3.5 ltr:pl-0 ltr:pr-3.5 flex items-center cursor-pointer">
                <img :src="this.showPass ? hidePasswordIcon : showPasswordIcon" :title="`${showPass ? 'hide' : 'show'}`"
                  alt="" />
              </div>
            </div>
            <p v-for="(error, index) of v$.formData.password.$errors" :key="error.uid"
              class="text-sm text-red-600 pr-2 ltr:pr-0 ltr:pl-2 mt-1">
              {{ index == 0 ? error.$message : '' }}
            </p>
          </div>
          <button class=" bg-primary text-white rounded-[10px] h-[50px] w-full flex items-center justify-center">{{
            $t('general.confirm') }}</button>
        </form>
      </div>
      <div class=" hidden max-w-[370px] xl:block">
        <img src="../../assets/images/Locked_store.svg" alt="">
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '../generic/Modal.vue';
// icons
import showPasswordIcon from '@/assets/auth/eye.svg';
import hidePasswordIcon from '@/assets/auth/hidden-eye.svg';
import { useVuelidate } from '@vuelidate/core';
import {
  buildStoreLink
} from "@/helpers";

export default {
  components: {
    Modal,
  },
  props: {
    store: {
      type: Object,
      required: true,
      default: () => ({})
    },
    isModalOpen: {
      type: Boolean,
      required: true,
      default: () => (false)
    },
  },
  data() {
    return {
      showPass: false,
      showPasswordIcon,
      hidePasswordIcon,
      v$: useVuelidate(),
      isProcessing: false,
      formData: {
        password: "",
      },
    };
  },
  validations() {
    return {
      formData: {
        password: {
          required: this.VALIDATIONS.password.required,
        },
      },
    };
  },
  methods: {
    buildStoreLink,
    onSubmit() {
      this.v$.$touch(); // vaildation
      if (this.v$.formData.$error) return;
      else {
        // add password to session storage to use it on the single store page.
        sessionStorage.setItem(this.$props.store.username, this.formData.password);
        const myCookie = useCookie('storePassword');
        myCookie.value = {
          name: this.$props.store.username,
          password: this.formData.password
        }
        this.makeRequest({
          url: `${this.APIREQUESTS.user.getStore.url}/${this.$props.store.username}?password=${this.formData.password}`,
          method: this.APIREQUESTS.user.getStore.method,
          includeUserToken: true,
          includeUID: true,
        }).then((res) => {
          if (res.status) {
            this.$router.push(this.buildStoreLink(this.$props.store && this.$props.store.username))
            this.closeModal(false)
          } else {
            this.notify({ type: 'error', msg: res?.message });
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    closeModal(val) {
      if (typeof val == "boolean")
        this.$emit('closeStorePasswordModal', val)
    },
  },
}
</script>

<style></style>